<template>
  <div>
    <topBanner2 :page="page" />

    <div class="bb-item" data-slug="portfolios" style="display: block;">
      <div class="vc_col-sm-6 bb-custom-side">
        <div class="content-wrapper">
          <div class="container">
            <div
              class="vc_separator wpb_content_element big vc_separator_align_left vc_sep_width_100 vc_sep_double vc_sep_pos_align_right vc_sep_color_grey vc_separator-has-text">
              <span class="vc_sep_holder vc_sep_holder_l"><span class="vc_sep_line"></span></span>
              <h4>Portfolios</h4><span class="vc_sep_holder vc_sep_holder_r"><span class="vc_sep_line"></span></span>
            </div>
            <ul id="portfolio-filter-oBTIBx9p91" class="portfolio-filters">
              <li class="active" data-filter="*">All</li>
              <li data-filter=".audio">Audio</li>
              <li data-filter=".illustrator">Illustrator</li>
              <li data-filter=".video">Video</li>
            </ul>
            <div id="portfolio-container-oBTIBx9p91" class="portfolio-container">
              <div class="portfolio-item illustrator">
                <img loading="lazy" decoding="async" width="493" height="476"
                  src="https://demo.focuxtheme.com/magicbook/wp-content/uploads/sites/10/2016/10/013e4a5544265d0000019ae9c632c1.jpg"
                  class="attachment-portfolio_thumbnail size-portfolio_thumbnail wp-post-image" alt="">
                <div class="mask">
                  <a href="https://demo.focuxtheme.com/magicbook/portfolio/relaxing-with-coffee/" target="_blank"
                    rel="portfolio" class="fancybox ajax">
                    <h4>Relaxing With Coffee</h4>
                    <p>Consectetur adipiscing elit. Integer commodo tristique odio, quis fringilla ligu...</p>
                  </a>
                  <a href="https://demo.focuxtheme.com/magicbook/portfolio/relaxing-with-coffee/" target="_blank"
                    class="more ajax"><i class="fa fa-info-circle"></i><span>Read
                      more</span></a>
                </div>
              </div>
              <div class="portfolio-item video">
                <img loading="lazy" decoding="async" width="582" height="800"
                  src="https://demo.focuxtheme.com/magicbook/wp-content/uploads/sites/10/2016/10/about.jpg"
                  class="attachment-portfolio_thumbnail size-portfolio_thumbnail wp-post-image" alt="">
                <div class="mask">
                  <a href="https://demo.focuxtheme.com/magicbook/portfolio/white-paint/" target="_blank" rel="portfolio"
                    class="fancybox ajax">
                    <h4>White Paint</h4>
                    <p>Consectetur adipiscing elit. Integer commodo tristique odio, quis fringilla ligu...</p>
                  </a>
                  <a href="https://demo.focuxtheme.com/magicbook/portfolio/white-paint/" target="_blank"
                    class="more ajax"><i class="fa fa-info-circle"></i><span>Read more</span></a>
                </div>
              </div>
              <div class="portfolio-item illustrator">
                <img loading="lazy" decoding="async" width="492" height="771"
                  src="https://demo.focuxtheme.com/magicbook/wp-content/uploads/sites/10/2016/10/01a1ea554b31d2000001bf726e9dd8.jpg"
                  class="attachment-portfolio_thumbnail size-portfolio_thumbnail wp-post-image" alt="">
                <div class="mask">
                  <a href="https://demo.focuxtheme.com/magicbook/portfolio/night-sky/" target="_blank" rel="portfolio"
                    class="fancybox ajax">
                    <h4>Night Sky</h4>
                    <p>Consectetur adipiscing elit. Integer commodo tristique odio, quis fringilla ligu...</p>
                  </a>
                  <a href="https://demo.focuxtheme.com/magicbook/portfolio/night-sky/" target="_blank"
                    class="more ajax"><i class="fa fa-info-circle"></i><span>Read more</span></a>
                </div>
              </div>
              <div class="portfolio-item audio">
                <img loading="lazy" decoding="async" width="476" height="498"
                  src="https://demo.focuxtheme.com/magicbook/wp-content/uploads/sites/10/2016/10/01e07f5544265e0000019ae9fe25f5.jpg"
                  class="attachment-portfolio_thumbnail size-portfolio_thumbnail wp-post-image" alt="">
                <div class="mask">
                  <a href="https://demo.focuxtheme.com/magicbook/portfolio/cavalier/" target="_blank" rel="portfolio"
                    class="fancybox ajax">
                    <h4>Cavalier</h4>
                    <p>Consectetur adipiscing elit. Integer commodo tristique odio, quis fringilla ligu...</p>
                  </a>
                  <a href="https://demo.focuxtheme.com/magicbook/portfolio/cavalier/" target="_blank" class="more ajax"><i
                      class="fa fa-info-circle"></i><span>Read more</span></a>
                </div>
              </div>
              <div class="portfolio-item video">
                <img loading="lazy" decoding="async" width="439" height="459"
                  src="https://demo.focuxtheme.com/magicbook/wp-content/uploads/sites/10/2016/10/0184f95544265e0000019ae9cd96d0.jpg"
                  class="attachment-portfolio_thumbnail size-portfolio_thumbnail wp-post-image" alt="">
                <div class="mask">
                  <a href="https://demo.focuxtheme.com/magicbook/portfolio/world-of-tomorrow/" target="_blank"
                    rel="portfolio" class="fancybox ajax">
                    <h4>World Of Tomorrow</h4>
                    <p>Consectetur adipiscing elit. Integer commodo tristique odio, quis fringilla ligu...</p>
                  </a>
                  <a href="https://demo.focuxtheme.com/magicbook/portfolio/world-of-tomorrow/" target="_blank"
                    class="more ajax"><i class="fa fa-info-circle"></i><span>Read more</span></a>
                </div>
              </div>
              <div class="portfolio-item illustrator">
                <img loading="lazy" decoding="async" width="445" height="460"
                  src="https://demo.focuxtheme.com/magicbook/wp-content/uploads/sites/10/2016/10/01f4df5544265e0000019ae9a846bc.jpg"
                  class="attachment-portfolio_thumbnail size-portfolio_thumbnail wp-post-image" alt="">
                <div class="mask">
                  <a href="https://demo.focuxtheme.com/magicbook/portfolio/practise/" target="_blank" rel="portfolio"
                    class="fancybox ajax">
                    <h4>Practise</h4>
                    <p>Consectetur adipiscing elit. Integer commodo tristique odio, quis fringilla ligu...</p>
                  </a>
                  <a href="https://demo.focuxtheme.com/magicbook/portfolio/practise/" target="_blank" class="more ajax"><i
                      class="fa fa-info-circle"></i><span>Read more</span></a>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>


    </div>


  </div>
</template>
<script>
import topleftbanner from '../components/topleftbanner.vue';
import topBanner2 from '../components/topBanner2.vue';
import rightBanner from '../components/rightBanner.vue';
export default {
  props: ["page"],

  components: { topBanner2, topleftbanner, rightBanner },
  methods: {
    toggleBrowsingContent() {
      this.$refs.heroImage.classList.toggle("browsing-content");
    },
  },
  computed: {
    stockList() {
      return this.$store.state.StockList
    }
  },

};
</script>


<style scoped lang="scss">
@import url(https://fonts.googleapis.com/css?family=Oxygen:400,300,700);

.ca-1 {
  background: url("https://farm1.staticflickr.com/571/21101592188_f5da31c3f5_o.jpg") no-repeat center center;
}

.ca-2 {
  background: url("https://watermark.lovepik.com/photo/20211210/large/lovepik-summer-watermelon-picture_501768510.jpg") no-repeat center center;
}

.ca-3 {
  background: url("https://watermark.lovepik.com/photo/20211210/large/lovepik-summer-watermelon-picture_501768510.jpg") no-repeat center center;
}

.ca-4 {
  background: url("https://watermark.lovepik.com/photo/20211210/large/lovepik-summer-watermelon-picture_501768510.jpg") no-repeat center center;
}

.ca-5 {
  background: url("https://farm6.staticflickr.com/5692/21342201074_aef835df8d_k.jpg") no-repeat center center;
}

.ca-6 {
  background: url("https://watermark.lovepik.com/photo/20211210/large/lovepik-summer-watermelon-picture_501768510.jpg") no-repeat center center;
}

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.clear-after:after,
.main-wrapper .scroll-content .sc-row .content-article .article-info .ai-footer:after,
.main-wrapper .scroll-content .sc-row:after,
.main-wrapper .hero-image .hero-content .hc-footer:after {
  content: "";
  display: block;
  clear: both;
}

body {
  text-rendering: auto;
  -webkit-font-smoothing: antialiased;
  font-family: Oxygen;
  color: white;
}

.main-wrapper {
  position: relative;
  width: 100vw;
  height: 100vh;
  overflow: hidden;
}

.main-wrapper .hero-image {
  z-index: 3;
  position: relative;
  width: 100%;
  height: 100%;
  background: url("https://c1.staticflickr.com/1/632/21136101110_1dde1c1a7e_o.jpg");
  background-size: cover;
  box-shadow: 0 5px 60px 10px rgba(0, 0, 0, 0.75);
  transition: all 0.5s ease;
}

.main-wrapper .hero-image.browsing-content {
  height: 40%;
  background-position: center -150px;
}

.main-wrapper .hero-image.browsing-content:after {
  opacity: 1;
  height: 100%;
}

.main-wrapper .hero-image.browsing-content .hcft-icon.closed {
  opacity: 0 !important;
}

.main-wrapper .hero-image.browsing-content .hcft-icon.opened {
  opacity: 1 !important;
}

.main-wrapper .hero-image:after {
  content: "";
  display: block;
  position: absolute;
  background: linear-gradient(0deg, black, rgba(0, 0, 0, 0));
  height: 50%;
  width: 100%;
  bottom: 0;
  left: 0;
  opacity: 0.65;
  transition: all 0.5s ease;
}

.main-wrapper .hero-image .hero-content {
  position: absolute;
  z-index: 4;
  width: 100%;
  padding: 40px;
  bottom: 0;
}

.main-wrapper .hero-image .hero-content .hc-label {
  font-size: 44px;
  text-transform: uppercase;
  font-weight: 700;
}

.main-wrapper .hero-image .hero-content .hc-desc {
  font-size: 22px;
  text-transform: uppercase;
  font-weight: 300;
}

.main-wrapper .hero-image .hero-content .hc-footer {
  margin-top: calc(40px / 1.5);
  line-height: 32px;
  font-size: 14px;
}

.main-wrapper .hero-image .hero-content .hc-footer .hcf-divider {
  float: left;
  margin: 7px 10px;
  height: 18px;
  width: 1px;
  background-color: white;
}

.main-wrapper .hero-image .hero-content .hc-footer .hcf-comments,
.main-wrapper .hero-image .hero-content .hc-footer .hcf-shares {
  float: left;
  text-transform: uppercase;
}

.main-wrapper .hero-image .hero-content .hc-footer .hcf-comments .amount,
.main-wrapper .hero-image .hero-content .hc-footer .hcf-shares .amount {
  margin-right: 5px;
  font-weight: 700;
}

.main-wrapper .hero-image .hero-content .hc-footer .hcf-toggle {
  float: right;
}

.main-wrapper .hero-image .hero-content .hc-footer .hcf-toggle .hcft-label {
  float: left;
  line-height: 32px;
  margin-right: 10px;
  text-transform: uppercase;
}

.main-wrapper .hero-image .hero-content .hc-footer .hcf-toggle .hcft-icon-holder {
  float: left;
  position: relative;
  width: 32px;
  height: 32px;
  text-align: center;
  background-color: rgba(0, 0, 0, 0.25);
  transition: background-color 0.25s ease;
}

.main-wrapper .hero-image .hero-content .hc-footer .hcf-toggle .hcft-icon-holder:hover {
  background-color: rgba(0, 0, 0, 0.5);
}

.main-wrapper .hero-image .hero-content .hc-footer .hcf-toggle .hcft-icon-holder .hcft-icon {
  cursor: pointer;
  line-height: 32px;
  width: 32px;
  left: 0;
  position: absolute;
  font-size: 14px;
  transition: all 0.5s ease;
}

.main-wrapper .hero-image .hero-content .hc-footer .hcf-toggle .hcft-icon-holder .hcft-icon.closed {
  opacity: 1;
}

.main-wrapper .hero-image .hero-content .hc-footer .hcf-toggle .hcft-icon-holder .hcft-icon.opened {
  opacity: 0;
}

.main-wrapper .scroll-content {
  position: absolute;
  top: 40%;
  left: 0;
  width: 100%;
  overflow: auto;
  height: calc(100% - 40%);
}

.main-wrapper .scroll-content .sc-row {
  z-index: 1;
}

.main-wrapper .scroll-content .sc-row .content-article {
  float: left;
  cursor: pointer;
  width: 50%;
  height: 360px;
  overflow: hidden;
  position: relative;
}

.main-wrapper .scroll-content .sc-row .content-article:after {
  content: "";
  display: block;
  position: absolute;
  background: linear-gradient(0deg, rgba(0, 0, 0, 0.85), rgba(0, 0, 0, 0.1));
  height: 100%;
  width: 100%;
  bottom: 0;
  left: 0;
  opacity: 1;
  transition: opacity 0.25s ease;
}

.main-wrapper .scroll-content .sc-row .content-article:hover:after {
  opacity: 0;
}

.main-wrapper .scroll-content .sc-row .content-article:hover .article-image {
  transform: scale(1.1) !important;
}

.main-wrapper .scroll-content .sc-row .content-article .article-image {
  width: 100%;
  height: 100%;
  background-size: cover;
  transform: scale(1);
  transition: all 0.25s ease;
}

.main-wrapper .scroll-content .sc-row .content-article .article-number {
  z-index: 2;
  position: absolute;
  top: 40px;
  left: 40px;
  font-size: 20px;
  font-weight: 700;
  letter-spacing: 2px;
}

.main-wrapper .scroll-content .sc-row .content-article .article-info {
  z-index: 2;
  position: absolute;
  bottom: 0;
  padding: 40px;
  text-transform: uppercase;
}

.main-wrapper .scroll-content .sc-row .content-article .article-info .ai-label {
  font-size: 20px;
  font-weight: 700;
  margin-bottom: calc(40px / 4);
}

.main-wrapper .scroll-content .sc-row .content-article .article-info .ai-desc {
  font-size: 16px;
  font-weight: 300;
}

.main-wrapper .scroll-content .sc-row .content-article .article-info .ai-footer {
  line-height: 20px;
  margin-top: calc(40px / 4);
}

.main-wrapper .scroll-content .sc-row .content-article .article-info .ai-footer .aif-comments,
.main-wrapper .scroll-content .sc-row .content-article .article-info .ai-footer .aif-shares {
  float: left;
  font-size: 14px;
}

.main-wrapper .scroll-content .sc-row .content-article .article-info .ai-footer .aif-comments .amount,
.main-wrapper .scroll-content .sc-row .content-article .article-info .ai-footer .aif-shares .amount {
  font-weight: 700;
  margin-right: 5px;
}

.main-wrapper .scroll-content .sc-row .content-article .article-info .ai-footer .aif-divider {
  float: left;
  height: 14px;
  margin: 3px 10px;
  width: 1px;
  background-color: white;
}
</style>
